import {Component, OnInit} from '@angular/core';
import {Permission} from "../../../interfaces/permission";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PermissionService} from "../../../services/permission.service";
import {PlantService} from "../../../services/plant.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Response} from "../../../interfaces/response";
import { IPlant } from 'src/app/interfaces/plant';


@Component({
  selector: 'app-plant-edit',
  templateUrl: './plant-edit.component.html',
  styleUrls: ['./plant-edit.component.scss']
})
export class PlantEditComponent implements OnInit {
  form: FormGroup;
  plant: IPlant;
  modoEdicion: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private plantService: PlantService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id_planta: ['', Validators.required],
      nom_planta:  ['', Validators.required],
    });
    this.route.params.subscribe(params => {
      if (params["id"] == undefined) {
        return;
      }

    this.modoEdicion = true;

    this.route.params.subscribe(
      params => {
        this.plantService.get(params.id)
        .subscribe(
          (res: Response) => {
               this.plant = res.data;
              this.form.patchValue({
              id_planta: this.plant.id_planta,
              nom_planta: this.plant.nom_planta
              });
          },
          err => console.log('HTTP Error', err)
        )
      }
    )

    ;
  });
  }



  submit() {

    const data = this.form.getRawValue();


    if (this.modoEdicion) {
      // editar el registro
      this.plantService.update(this.plant.id, data).subscribe(
        res => {
          this.router.navigate(['/plants']);
        }
      )

   } else {
     // agregar el registro
     this.plantService.create(data).subscribe(
      res => {
        this.router.navigate(['/plants']);
      }
    );

   }
  }
}
